import React from "react";

import {
  Edit,
  Loading,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useEditController,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";

import { CommodityForm } from "./CommodityForm";
import { DialogSaveButton } from "./DialogSaveButton";
import { DeepDeleteButton } from "./DeepDeleteButton";

const EditActions = (props) => (
  <TopToolbar>
    <BackButton {...props} />
  </TopToolbar>
);

const EditToolbar = (props) => (
  <Toolbar style={{ justifyContent: "space-between" }}>
    <DialogSaveButton {...props} />
    <DeepDeleteButton {...props} />
  </Toolbar>
);

export const CommodityEdit = (props) => {
  const { record } = useEditController(props);

  if (!record) return <Loading />;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Commodity" />}
      mutationMode="pessimistic"
      actions={<EditActions {...props} />}
    >
      <SimpleForm
        submitOnEnter={false}
        toolbar={<EditToolbar {...props} record={record} />}
      >
        <CommodityForm {...props} record={record} />
      </SimpleForm>
    </Edit>
  );
};
